<template>
  <div v-if="auth">
    <div class="navbar">
      <Menu />
    </div>
    <div class="main uk-flex">
      <div class="content">
        <router-view />
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.sidebar {
  z-index: 90;
}
.main {
  min-height: 100vh;
}
.content {
  flex: 1;
  min-width: $content-min-width;
  padding: $spacing-medium;
  margin-top: 48px;
}
.navbar {
  min-width: $content-min-width + $global-menu-width + $spacing-medium;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 99;
}
</style>

<script lang="ts">
import { Vue, Options } from "vue-class-component";
import { Watch } from "vue-property-decorator";
import Menu from "../components/organisms/Menu.vue";
import { Auth } from "../types";
import Router from "../router";
import Store from "../store";

@Options({
  components: {
    Menu
  }
})
export default class Main extends Vue {
  auth!: Partial<Auth> | null;
  isDepartmentMenu = true;
  isApplicantMenu = false;
  isAnalyticsMenu = false;
  isOrganizationMenu = false;

  private setActive() {
    if (this.$route.fullPath.indexOf("/analytics") >= 0) {
      this.isAnalyticsMenu = true;
      this.isDepartmentMenu = false;
      this.isApplicantMenu = false;
      this.isOrganizationMenu = false;
    } else if (
      this.$route.fullPath.indexOf("/as") >= 0 ||
      this.$route.fullPath.indexOf("/system") >= 0 ||
      this.$route.fullPath.indexOf("/users") >= 0
    ) {
      this.isAnalyticsMenu = false;
      this.isDepartmentMenu = false;
      this.isApplicantMenu = false;
      this.isOrganizationMenu = false;
    } else if (this.$route.fullPath.indexOf("/organization") >= 0) {
      this.isAnalyticsMenu = false;
      this.isDepartmentMenu = false;
      this.isApplicantMenu = false;
      this.isOrganizationMenu = true;
    } else if (this.$route.fullPath.indexOf("/applicants") >= 0) {
      this.isApplicantMenu = true;
      this.isDepartmentMenu = false;
      this.isAnalyticsMenu = false;
      this.isOrganizationMenu = false;
    } else {
      this.isDepartmentMenu = true;
      this.isAnalyticsMenu = false;
      this.isApplicantMenu = false;
      this.isOrganizationMenu = false;
      if (this.$route.fullPath === "/") {
        Router.push({ path: `/clients/:clientId/departments/all/dashboard` });
      }
    }
  }
  @Watch("$route")
  onRouteChanged() {
    this.setActive();
  }
  beforeCreate() {
    this.auth = Store.getInstance().getAuth();
  }
  beforeMount() {
    this.setActive();
  }
}
</script>
